import React from "react";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import { FormControl } from "material-ui/Form";
import CInput from "uis/CInput";
import Select from "material-ui/Select";

import Keywords from "assets/data/Keywords";

const styles = theme => {
  return {
    dialogContent: {
      width: "auto"
    },
    errorMessage: {
      fontSize: ".9rem",
      margin: "0 20px 10px"
    },
    button: {
      margin: theme.spacing.unit
    },
    container: {
      display: "flex",
      flexWrap: "wrap",
      margin: "3rem 2rem"
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 140
    },
    flexItem: {
      display: "flex",
      flexWrap: "wrap",
      marginRight: 30
    },
    keyword: {
      margin: "auto 0",
      fontSize: 18
    },
    selectInput: { margin: "auto 0" }
  };
};

class ReplaceModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      key1: 1,
      key2: 1,
      key3: 1,
      key4: 1,
      key5: 1
    };
  }

  handleChange = name => event => {
    this.setState({ [name]: Number(event.target.value) });
  };

  render() {
    const { classes, replaceModal } = this.props;
    const { open } = replaceModal;

    return (
      <Dialog open={open} fullWidth={true} maxWidth={"md"}>
        <DialogTitle id="form-dialog-title">キーワード一括置換</DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <h3 color="secondary">※基本設問の全ての設問文に適用されます</h3>
          <form className={classes.container}>
            <div className={classes.flexItem}>
              <div className={classes.keyword}>当社→</div>
              <FormControl className={classes.formControl}>
                <Select
                  native
                  value={this.state.key1}
                  onChange={this.handleChange("key1")}
                  input={
                    <CInput
                      className={classes.selectInput}
                      id="age-native-simple"
                    />
                  }
                >
                  {Keywords.KEY1.map(keyword => (
                    <option key={keyword.id} value={keyword.id}>
                      {keyword.word}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={classes.flexItem}>
              <div className={classes.keyword}>社員→</div>
              <FormControl className={classes.formControl}>
                <Select
                  native
                  value={this.state.key2}
                  onChange={this.handleChange("key2")}
                  input={
                    <CInput
                      className={classes.selectInput}
                      id="age-native-simple"
                    />
                  }
                >
                  {Keywords.KEY2.map(keyword => (
                    <option key={keyword.id} value={keyword.id}>
                      {keyword.word}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={classes.flexItem}>
              <div className={classes.keyword}>経営トップ層→</div>
              <FormControl className={classes.formControl}>
                <Select
                  native
                  value={this.state.key3}
                  onChange={this.handleChange("key3")}
                  input={
                    <CInput
                      className={classes.selectInput}
                      id="age-native-simple"
                    />
                  }
                >
                  {Keywords.KEY3.map(keyword => (
                    <option key={keyword.id} value={keyword.id}>
                      {keyword.word}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={classes.flexItem}>
              <div className={classes.keyword}>上司→</div>
              <FormControl className={classes.formControl}>
                <Select
                  native
                  value={this.state.key4}
                  onChange={this.handleChange("key4")}
                  input={
                    <CInput
                      className={classes.selectInput}
                      id="age-native-simple"
                    />
                  }
                >
                  {Keywords.KEY4.map(keyword => (
                    <option key={keyword.id} value={keyword.id}>
                      {keyword.word}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={classes.flexItem}>
              <div className={classes.keyword}>部署→</div>
              <FormControl className={classes.formControl}>
                <Select
                  native
                  value={this.state.key5}
                  onChange={this.handleChange("key5")}
                  input={
                    <CInput
                      className={classes.selectInput}
                      id="age-native-simple"
                    />
                  }
                >
                  {Keywords.KEY5.map(keyword => (
                    <option key={keyword.id} value={keyword.id}>
                      {keyword.word}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button raised onClick={this.props.handleClose}>
            キャンセル
          </Button>
          <Button raised onClick={() => this.props.replaceAll(this.state)}>
            置換
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(ReplaceModal);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseWord/ReplaceModal.jsx